import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 16px;
`;

export const CardWrapper = styled.div`
  width: 100%;

  > div {
    border-radius: 12px;
    box-shadow: 0 18px 50px rgba(17, 48, 89, 0.18);
    margin: 0;
    overflow: hidden;
  }

  .card-body {
    padding: 36px 28px 28px;

    @media (max-width: 576px) {
      padding: 28px 20px 24px;
    }
  }

  .ant-form-item-label > label {
    color: rgba(0, 0, 0, 0.65);
    font-weight: 500;
  }

  .ant-input-affix-wrapper {
    border-radius: 8px;
  }

  .ant-input-affix-wrapper .anticon {
    color: rgba(0, 0, 0, 0.35);
  }

  .ant-btn-primary {
    border-radius: 8px;
    height: 44px;
    letter-spacing: 0.04em;
  }
`;

export const Title = styled.h2`
  color: #444;
  font-weight: 400;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 1.5;
  margin: 0 auto 24px;
  text-align: center;
`;

export const Image = styled.img`
  display: block;
  height: 48px;
  margin: 0 auto 16px;
  max-width: 240px;
  object-fit: contain;
  width: auto;
`;
